import React from "react";
import CommercialSearchResultPage from "../../../templates/commercial-search-results-template";

const SearchResultCommSales = (props) => {

    const fullpath = props.location.pathname
    const location = props.location
    const fullpathone = props.location
    // const searchParams = parseSearchUrl("sales", fullpath);

    return (
        <React.Fragment>
            <CommercialSearchResultPage 
                locationname="/commercial-property/for-sale/" 
                pcategorytype="commercial" 
                ptype="sales" 
                ptypetag="for-sale" 
                pstatustype="For Sale"
                fullpathone={fullpathone} 
                fullpathname={fullpath}
                {...props}
                tag={"commercial"}
            />
        </React.Fragment>
    );
};

export default SearchResultCommSales;
